module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud-da9a79eca14b37f745b4d3c40c50da38.png";